// Values that tie the code to one study and its location. See README.md.
//
// Pure data: no imports, no functions, no process.env. Constants.js imports
// this file, so it ships in both browser bundles and must never hold a secret.
// Keys match the Python library's config/general_*.json.
const GENERAL_CONFIG = {
  timezone: 'Asia/Kolkata',
  languages: ['gu', 'hi', 'es'],
  // Dot, not dash: the Apache vhost is dev.api2.community-hats.net. The dashed
  // form has no DNS record at all.
  api_url: 'https://dev.api2.community-hats.net',
  api_url_front: 'https://dev.api2.community-hats.net',
};

export default GENERAL_CONFIG;
